// The URL parameter names of a search: a contract with the outside (the platform's lowest-fare links, partner
// deep links, our short links), not a store internal — each store owns how its parameters are read and written.
export const PARAM_TRIP_TYPE = 'tripType';
export const PARAM_CABIN_CLASS = 'cabinClass';
export const PARAM_ADULTS = 'adults';
export const PARAM_CHILDREN = 'children';
export const PARAM_INFANTS = 'infants';
export const PARAM_LEGS_FROM_CODE = 'legs.from.code';
export const PARAM_LEGS_FROM_TYPE = 'legs.from.type';
export const PARAM_LEGS_TO_CODE = 'legs.to.code';
export const PARAM_LEGS_TO_TYPE = 'legs.to.type';
export const PARAM_LEGS_DATE = 'legs.date';

export const PARAM_STOPS = 'stops';
export const PARAM_STOPS_DURATION_START = 'stopDuration.start';
export const PARAM_STOPS_DURATION_END = 'stopDuration.end';
export const PARAM_ALLOW_AIRPORT_CHANGE = 'allowAirportChange';
export const PARAM_LEGS_HOUR_DEPARTURE_BEGIN = 'legs.hour.departure.begin';
export const PARAM_LEGS_HOUR_ARRIVAL_BEGIN = 'legs.hour.arrival.begin';
export const PARAM_LEGS_HOUR_DEPARTURE_END = 'legs.hour.departure.end';
export const PARAM_LEGS_HOUR_ARRIVAL_END = 'legs.hour.arrival.end';
export const PARAM_LEGS_DURATION = 'legs.duration';
export const PARAM_LEGS_UNSELECTED_AIRLINES = 'legs.unselectedAirlines';
export const PARAM_LEGS_UNSELECTED_AIRPORTS = 'legs.unselectedAirports';
